import {configureStore} from '@reduxjs/toolkit'
import { residentPortalApi } from './residentPortalApi'
import './inviteScanApi'
import router from "./reducers/routerReducer";
import authSlice from "./reducers/authSlice";
import ui from "./reducers/uiReducer";


const store = configureStore({
  reducer: {
    router: router.reducer,
    auth: authSlice.reducer,
    ui: ui.reducer,
    [residentPortalApi.reducerPath]: residentPortalApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: residentPortalApi,
      },
      immutableCheck: false,
      serializableCheck: false,
    }).concat(residentPortalApi.middleware)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store;
